import 'reflect-metadata';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import 'aos/dist/aos.css';
import '../src/style/scss/main.scss';
import '../src/style/css/feather.css';
import './index.scss';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Bounce, ToastContainer } from 'react-toastify';

import store from './core/data/redux/store';
import { base_path } from './environment';
import { AuthProvider } from './feature-module/auth/context/auth-context';
import Feature from './feature-module/feature';

const rootElement = document.getElementById('root');

const queryClient = new QueryClient();

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <AuthProvider>
            <BrowserRouter basename={base_path}>
              <Feature />
            </BrowserRouter>
          </AuthProvider>
        </Provider>
      </QueryClientProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
    </React.StrictMode>
  );
} else {
  console.error("Element with id 'root' not found.");
}
